import { take, call, put } from "redux-saga/effects";
import { submissions as actionTypes } from "$constants/action-types";
import { fetchAllSuccess } from "$actions/submissions";
import axios from "axios";
import { alert } from "./root";

const fetchAll = (projectId, taskFormId) =>
  axios.get(`/projects/${projectId}/task_forms/${taskFormId}/submissions`);
const createReport = (projectId, type, q, insightFilters = {}) =>
  axios.post(`/submissions/reports`, {
    q: { project_id_eq: projectId, ...q },
    report: { type },
    filters: insightFilters,
  });
const createReportForEmails = (projectId, report, q, insightFilters = {}) =>
  axios.post(`/submissions/reports`, {
    q: { project_id_eq: projectId, ...q },
    report: report,
    filters: insightFilters,
  });

function* watchFetchAll() {
  while (true) {
    const action = yield take(actionTypes.FETCH_ALL);
    const { data } = yield call(fetchAll, action.projectId, action.taskFormId);
    const submissions = data.data.map((item) => {
      item.project_id = action.projectId;
      item.task_form_id = action.taskFormId;
      return item;
    });

    yield put(fetchAllSuccess(submissions));
  }
}

function* watchCreateReport() {
  while (true) {
    const action = yield take(actionTypes.CREATE_REPORT);
    const { data } = yield call(
      createReport,
      action.projectId,
      action.fileType,
      action.filters,
      action.insightFilters
    );
    const alertMessage = `We will send you an e-mail with a link that you can
      download the report in 5 minutes.`;

    yield alert("Report Queued", alertMessage);
  }
}
function* watchCreateReportForEmails() {
  while (true) {
    const action = yield take(actionTypes.CREATE_REPORT_EMAILS);
    const { data } = yield call(
      createReportForEmails,
      action.projectId,
      action.report,
      action.filters,
      action.insightFilters
    );
    const alertMessage = `We will send you an e-mail with a link that you can
      download the report in 5 minutes.`;

    yield alert("Report Queued", alertMessage);
  }
}

export const watchers = [
  watchFetchAll,
  watchCreateReport,
  watchCreateReportForEmails,
];



// WEBPACK FOOTER //
// ./src/sagas/submissions.js